<template>
  <v-card>
    <v-card-title>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs2>
        <div class="title">Premium</div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.totTarfRate }}</td>
        <td class="text-xs-left">{{ formatDate(props.item.effDate) }}</td>
        <td class="text-xs-left">{{ formatDate(props.item.expDate) }}</td>
        <td class="text-xs-left">{{ props.item.gap }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doCreate">New Premium<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff Premium?
      <div class="title">{{deleteTarfPrem}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { mapActions } from 'vuex'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number.js'
export default {
  data() {
    return {
      headers: [
        { text: 'Total Tariff Rate', value: 'totTarfRate' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Gross Annual Premium', value: 'gap' },
        TableConst.tableActionHeader
      ],
      loading: false,
      deleteTarfPrem: '',
      promptRemove: false
    }
  },
  watch: {
    'fetchPrem': function(value) {
      if (value !== false) {
        this.fetchData(this.ids.benefit)
      }
    }
  },
  methods: {
    ...mapActions([
      'tariffBenefitInit'
    ]),
    async fetchData(benefit) {
      const expand = {
        busCls: this.ids.busCls,
        tarf: this.ids.tarf,
        benefit: benefit,
        effDate: this.ids.benEffDate
      }
      this.loading = true
      await this.tariffBenefitInit(expand)
      const apiURI = this.$store.state.parameters.tariff.benefit.menu.tarfPrems
      if (apiURI) {
        try {
          const expand = {
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: benefit,
            effDate: this.ids.effDate
          }
          this.items = []
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tarfPrems = []
            data.map((tarfPrem) => {
              const convertList = {
                busCls: tarfPrem.busCls,
                tarf: tarfPrem.tarf,
                benefit: tarfPrem.benefit,
                totTarfRate: formatDisplayNumber(tarfPrem.totTarfRate),
                effDate: tarfPrem.effDate,
                expDate: tarfPrem.expDate,
                gap: formatDisplayNumber(tarfPrem.gap)
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid API Url')
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doCreate() {
      this.$emit('doCreate')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTarfPrem = data
        this.deleteTarfPrem = data.totTarfRate + ' - ' + data.effDate
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.tariff.benefit.menu.tarfPremDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.ids.busCls,
          tarf: this.ids.tarf,
          benefit: this.ids.benefit,
          effDate: new Date(this.selectedTarfPrem.effDate),
          totTarfRate: removeFormatNumber(this.selectedTarfPrem.totTarfRate),
          expDate: this.removeFormatDate(this.selectedTarfPrem.expDate),
          gap: removeFormatNumber(this.selectedTarfPrem.gap)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.benefit)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff Rate')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    ids: Object,
    fetchPrem: Boolean
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
